import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaArrowRight, FaBell, FaExclamationCircle } from 'react-icons/fa';

import { fetchPublishedSystemUpdates } from '../utils/systemUpdates';
import '../styles/SystemUpdates.css';

const toDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

const formatDate = (value) => {
    const date = toDate(value);
    if (!date) return '';
    return new Intl.DateTimeFormat('ms-MY', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'Asia/Kuala_Lumpur',
    }).format(date);
};

const categoryLabel = {
    feature: 'Fungsi baharu',
    improvement: 'Penambahbaikan',
    maintenance: 'Penyelenggaraan',
    notice: 'Makluman',
};

const UpdateAction = ({ update }) => {
    if (!update.actionUrl) return null;
    const label = update.actionLabel || 'Ketahui lebih lanjut';
    const content = <>{label} <FaArrowRight /></>;

    if (update.actionUrl.startsWith('/')) {
        return <Link to={update.actionUrl}>{content}</Link>;
    }
    return <a href={update.actionUrl} target="_blank" rel="noreferrer">{content}</a>;
};

function SystemUpdates() {
    const [updates, setUpdates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        fetchPublishedSystemUpdates()
            .then((items) => {
                if (active) setUpdates(items);
            })
            .catch((loadError) => {
                console.error('[Makluman Etikaf] Gagal membaca:', loadError);
                if (active) setError('Makluman belum dapat dimuatkan. Cuba semula sebentar lagi.');
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => { active = false; };
    }, []);

    return (
        <div className="system-updates-page">
            <header className="system-updates-header">
                <Link className="system-updates-back" to="/dashboard"><FaArrowLeft /> Dashboard</Link>
                <span>DARIPADA ETIKAF</span>
                <h1>Semua makluman</h1>
                <p>Fungsi baharu, penambahbaikan dan makluman rasmi untuk pengurusan masjid.</p>
            </header>

            {loading ? (
                <div className="system-updates-loading"><span /><span /><span /></div>
            ) : error ? (
                <div className="system-updates-state error"><FaExclamationCircle /><strong>{error}</strong></div>
            ) : updates.length === 0 ? (
                <div className="system-updates-state"><FaBell /><strong>Belum ada makluman daripada Etikaf.</strong></div>
            ) : (
                <div className="system-updates-list">
                    {updates.map((update, index) => (
                        <article className="system-update-card" key={update.id}>
                            <div className="system-update-card-meta">
                                <span>{categoryLabel[update.category] || 'Makluman'}</span>
                                <time>{formatDate(update.publishedAt || update.updatedAt)}</time>
                                {index === 0 && <em>TERKINI</em>}
                            </div>
                            <h2>{update.title}</h2>
                            <p>{update.summary || update.description || ''}</p>
                            <UpdateAction update={update} />
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
}

export default SystemUpdates;
